import React from 'react'
import PropTypes from 'prop-types'
import AdminButtons from './AdminButtons'
import OwnerButtons from './OwnerButtons'
import TemplateButtons from './TemplateButtons'

export default class Buttons extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    document: PropTypes.object,
    url: PropTypes.bool,
    fromTemplate: PropTypes.bool
  }

  render() {
    if (this.props.url) {
      return <AdminButtons document={this.props.document} />
    } else {
      if (this.props.fromTemplate) {
        return <TemplateButtons document={this.props.document} />
      } else {
        return <OwnerButtons document={this.props.document} />
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Buttons/index.js